import cl from '@/utils/console/cl'
import urls from '@/utils/urls/urls'
import Link from 'next/link'
import React from 'react'
import BlogCard from './BlogCard'

const BlogPage = async () => {

        let blogs = [];

        try {
            const res = await fetch(urls?.blog, {
                cache: 'no-cache'
            })
            
            if (res.ok) {
                const contentType = res.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    try {
                        const data = await res.json()
                        blogs = Array.isArray(data?.data) ? data?.data : [];
                    } catch (parseError) {
                        console.error('Error parsing blogs JSON:', parseError);
                        blogs = [];
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching blogs:', error);
            blogs = [];
        }
        // cl('blogs', blogs);
        return (
            <>
                {/* preloader */}

                {/* preloader end */}
                {/* header area */}
                {/* header area end */}
                {/* popup search */}

                {/* popup search end */}
                {/* sidebar-popup */}

                {/* sidebar-popup end */}
                <main className="main">
                    {/* breadcrumb */}
                    <div
                        className="site-breadcrumb"
                        style={{ background: "url(../../assets/img/breadcrumb/01.jpg)" }}
                    >
                        <div className="container">
                            <h2 className="breadcrumb-title">Our Blog</h2>
                            <ul className="breadcrumb-menu">
                                <li>
                                    <Link href="/">Home</Link>
                                </li>
                                <li className="active">Blogs</li>
                            </ul>
                        </div>
                    </div>
                    {/* breadcrumb end */}
                    {/* blog-area */}
                    <div className="blog-area py-120">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 mx-auto">
                                    <div
                                        className="site-heading text-center wow fadeInDown"
                                        data-wow-delay=".25s"
                                    >
                                        <span className="site-title-tagline">
                                            <i className="fas fa-solar-panel" /> Our Blog
                                        </span>
                                        <h2 className="site-title">
                                            Our Latest News &amp; <span>Blog</span>
                                        </h2>
                                        <div className="heading-divider" />
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                {
                                    blogs?.map((blog: any) => (
                                        <div className="col-md-6 col-lg-4" key={blog?.id}>
                                            <BlogCard item={blog} />
                                        </div>
                                    ))
                                }
                                {/* <div className="col-md-6 col-lg-4">
                                <div className="blog-item wow fadeInUp" data-wow-delay=".25s">
                                    <div className="blog-item-img">
                                        <img src="assets/img/blog/01.jpg" alt="Thumb" />
                                    </div>
                                    <div className="blog-date">
                                        <strong>20</strong>
                                        <span>Aug</span>
                                    </div>
                                    <div className="blog-item-info">
                                        <div className="blog-item-meta">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-user-circle" /> By Alicia Davis
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-comments" /> 2.5k Comments
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <h4 className="blog-title">
                                            <a href="blog-single.html">
                                                There are many variations of passages orem available.
                                            </a>
                                        </h4>
                                        <p>
                                            It is a long established fact that a reader will majority have
                                            suffered distracted readable.
                                        </p>
                                        <a className="theme-btn" href="blog-single.html">
                                            Read More
                                            <i className="fas fa-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <div className="blog-item wow fadeInDown" data-wow-delay=".25s">
                                    <div className="blog-item-img">
                                        <img src="assets/img/blog/02.jpg" alt="Thumb" />
                                    </div>
                                    <div className="blog-date">
                                        <strong>25</strong>
                                        <span>Aug</span>
                                    </div>
                                    <div className="blog-item-info">
                                        <div className="blog-item-meta">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-user-circle" /> By Alicia Davis
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-comments" /> 1.2k Comments
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <h4 className="blog-title">
                                            <a href="blog-single.html">
                                                Generator internet repeat tend word chunk necessary.
                                            </a>
                                        </h4>
                                        <p>
                                            It is a long established fact that a reader will majority have
                                            suffered distracted readable.
                                        </p>
                                        <a className="theme-btn" href="blog-single.html">
                                            Read More
                                            <i className="fas fa-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <div className="blog-item wow fadeInUp" data-wow-delay=".25s">
                                    <div className="blog-item-img">
                                        <img src="assets/img/blog/03.jpg" alt="Thumb" />
                                    </div>
                                    <div className="blog-date">
                                        <strong>28</strong>
                                        <span>Aug</span>
                                    </div>
                                    <div className="blog-item-info">
                                        <div className="blog-item-meta">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-user-circle" /> By Alicia Davis
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-comments" /> 2.8k Comments
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <h4 className="blog-title">
                                            <a href="blog-single.html">
                                                Survived only five centuries but also the leap into.
                                            </a>
                                        </h4>
                                        <p>
                                            It is a long established fact that a reader will majority have
                                            suffered distracted readable.
                                        </p>
                                        <a className="theme-btn" href="blog-single.html">
                                            Read More
                                            <i className="fas fa-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <div className="blog-item wow fadeInUp" data-wow-delay=".25s">
                                    <div className="blog-item-img">
                                        <img src="assets/img/blog/01.jpg" alt="Thumb" />
                                    </div>
                                    <div className="blog-date">
                                        <strong>20</strong>
                                        <span>Aug</span>
                                    </div>
                                    <div className="blog-item-info">
                                        <div className="blog-item-meta">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-user-circle" /> By Alicia Davis
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-comments" /> 2.5k Comments
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <h4 className="blog-title">
                                            <a href="blog-single.html">
                                                There are many variations of passages orem available.
                                            </a>
                                        </h4>
                                        <p>
                                            It is a long established fact that a reader will majority have
                                            suffered distracted readable.
                                        </p>
                                        <a className="theme-btn" href="blog-single.html">
                                            Read More
                                            <i className="fas fa-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <div className="blog-item wow fadeInDown" data-wow-delay=".25s">
                                    <div className="blog-item-img">
                                        <img src="assets/img/blog/02.jpg" alt="Thumb" />
                                    </div>
                                    <div className="blog-date">
                                        <strong>25</strong>
                                        <span>Aug</span>
                                    </div>
                                    <div className="blog-item-info">
                                        <div className="blog-item-meta">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-user-circle" /> By Alicia Davis
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-comments" /> 1.2k Comments
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <h4 className="blog-title">
                                            <a href="blog-single.html">
                                                Generator internet repeat tend word chunk necessary.
                                            </a>
                                        </h4>
                                        <p>
                                            It is a long established fact that a reader will majority have
                                            suffered distracted readable.
                                        </p>
                                        <a className="theme-btn" href="blog-single.html">
                                            Read More
                                            <i className="fas fa-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <div className="blog-item wow fadeInUp" data-wow-delay=".25s">
                                    <div className="blog-item-img">
                                        <img src="assets/img/blog/03.jpg" alt="Thumb" />
                                    </div>
                                    <div className="blog-date">
                                        <strong>28</strong>
                                        <span>Aug</span>
                                    </div>
                                    <div className="blog-item-info">
                                        <div className="blog-item-meta">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-user-circle" /> By Alicia Davis
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="far fa-comments" /> 2.8k Comments
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <h4 className="blog-title">
                                            <a href="blog-single.html">
                                                Survived only five centuries but also the leap into.
                                            </a>
                                        </h4>
                                        <p>
                                            It is a long established fact that a reader will majority have
                                            suffered distracted readable.
                                        </p>
                                        <a className="theme-btn" href="blog-single.html">
                                            Read More
                                            <i className="fas fa-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div> */}
                            </div>
                            {/* pagination */}
                            {/* <div className="pagination-area">
                            <ul className="pagination">
                                <li className="page-item">
                                    <a className="page-link" href="#" aria-label="Previous">
                                        <span aria-hidden="true">
                                            <i className="fas fa-arrow-left" />
                                        </span>
                                    </a>
                                </li>
                                <li className="page-item active">
                                    <a className="page-link" href="#">
                                        1
                                    </a>
                                </li>
                                <li className="page-item">
                                    <a className="page-link" href="#">
                                        2
                                    </a>
                                </li>
                                <li className="page-item">
                                    <a className="page-link" href="#">
                                        3
                                    </a>
                                </li>
                                <li className="page-item">
                                    <a className="page-link" href="#" aria-label="Next">
                                        <span aria-hidden="true">
                                            <i className="fas fa-arrow-right" />
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div> */}
                            {/* pagination end */}
                        </div>
                    </div>
                    {/* blog-area end */}
                </main>
                {/* footer area */}

                {/* footer area end */}
                {/* scroll-top */}
                <a href="#" id="scroll-top">
                    <i className="far fa-arrow-up" />
                </a>
                {/* scroll-top end */}
                {/* js */}
            </>

        )
    }

export default BlogPage
